'use client';

import { SpeedInsights as VercelSpeedInsights } from '@vercel/speed-insights/next';
import { filterSpeedInsightsEvent } from '@/lib/analytics/speed-insights';

export function SpeedInsights() {
  return (
    <VercelSpeedInsights sampleRate={1} beforeSend={filterSpeedInsightsEvent} />
  );
}
